// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xSOhCEc9zsV68zOlfEy7{padding:0}.Oubr2YFzFBoV0qS9x5Ot{flex-wrap:wrap;align-items:center;gap:4px;padding:8px 12px;display:flex}.SWiKTZa2QhodoapITQDx,.ilZImiWyVPA5ywRJiC5i{padding:4px}.O2kYEDIg5FgesGR5zMlS{flex-direction:column;display:flex}.V1utULTqBQsYt_jiuNEa{text-align:center;padding:8.5px}.conpTbWf270rO7rIjCNz{padding-top:4px;padding-bottom:4px;display:inline-block}.a021v2Se8Eaq2b8vT0WY input{height:16px}.bRCAdRtGbj8eJFnu88ba{align-items:center;padding-top:4px;padding-bottom:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdownContentWrap": `xSOhCEc9zsV68zOlfEy7`,
	"selectedInboxesWrap": `Oubr2YFzFBoV0qS9x5Ot`,
	"search": `SWiKTZa2QhodoapITQDx`,
	"subList": `ilZImiWyVPA5ywRJiC5i`,
	"searchTagsList": `O2kYEDIg5FgesGR5zMlS`,
	"noResult": `V1utULTqBQsYt_jiuNEa`,
	"newInboxLabel": `conpTbWf270rO7rIjCNz`,
	"selectPlaceholder": `a021v2Se8Eaq2b8vT0WY`,
	"withChipPadding": `bRCAdRtGbj8eJFnu88ba`
};
export default ___CSS_LOADER_EXPORT___;
